<template>
    <div class="form-group" :class="{ 'has-error': hasErro }">
        <label class="control-label custom-font">{{ label }}</label>
        <div class="inputgroupcontainer">
            <div class="input-group">
                <span class="input-group-addon">
                    <font-awesome-icon :icon="'user'" />
                </span>

                <div class="autocomplete-wrapper">
                    <input 
                        ref="input" 
                        type="text" 
                        class="form-control" 
                        v-model="query"
                        v-validate="{ required: isRequired }"
                        name="sshd_responsavel"
                        autocomplete="off"
                        @input="onInput"
                        @keydown.down.prevent="navegar(1)" 
                        @keydown.up.prevent="navegar(-1)"
                        @keydown.enter.prevent="selecionarAtual"
                     />
                    <ul class="result-list" v-show="showResults">
                        <li 
                            v-for="(item, index) in resultados" 
                            :key="`${item.sshd}-${index}`" 
                            @click="selecionar(item)"
                            :class="[
                                'result-list-item', 
                                { 'ativo': index === selectedIndex }
                            ]"
                        >
                            {{ item.nome }} ({{ item.sshd }})
                        </li>
                    </ul>
                </div>
            </div>
            <!-- Erro -->
            <small v-if="hasErro" class="help-block">
                Preenchimento obrigatório!
            </small>
        </div>
    </div>
</template>
  
<script>
import { request } from '@/request'
export default {
    name: 'SelectFuncionario',
    inject: ['$validator'],
    props: {
        value: String,
        label: {
            type: String,
            default: 'Funcionário'
        },
        placeholder: String,
        name: {
            type: String,
            required: true
        },
        isRequired: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            query: null,
            resultados: [],
            delay: null,
            selectedIndex: -1,
            error: false
        }
    },
    watch: {
        value: {
            handler(val) {
                if (!val) {
                    this.query = ''
                } else {
                    this.atualizarQueryComFuncionario(val)
                }
            },
            immediate: true
        },
    },
    computed: {
        hasErro() {
            return this.$validator.errors.has(this.name)
        },
        showResults() {
            return this.resultados.length > 0
        }
    },
    methods: {
        atualizarQueryComFuncionario(sshd) {
            request.get(`/funcionario?search=${sshd}`)
                .then(response => {
                    const funcionario = response.data.find(f => f.sshd.toUpperCase() === sshd.toUpperCase());
                    if (funcionario) {
                        this.query = `${funcionario.sshd} - ${funcionario.nome}`;
                    } else {
                        this.query = sshd;
                    }
                })
                .catch(error => {
                    console.error("Erro ao buscar funcionário: ", error);
                    this.query = sshd;
                });
        },
        buscarFuncionarios() {
            clearTimeout(this.delay)

            if (!this.query || this.query.length < 2) {
                this.resultados = []
                return
            }

            // delay do fetch para não bater a API a cada tecla
            this.delay = setTimeout(() => {
                request.get(`/funcionario?search=${this.query}`)
                    .then(response => {
                        this.resultados = response.data
                        this.selectedIndex = 0
                    })
                    .catch(() => {
                        this.resultados = []
                        this.selectedIndex = -1
                    })
            }, 300)
        },
        selecionar(item) {
            this.query = `${item.sshd} - ${item.nome}`
            this.mostrarLista = false
            this.resultados = []
            this.$emit('input', item.sshd)

            // this.$validator.validate(this.name);
        },
        selecionarAtual() {
            if (this.resultados.length > 0 && this.selectedIndex >= 0) {
                this.selecionar(this.resultados[this.selectedIndex])
            }
        },
        navegar(direcao) {
            if (!this.resultados.length) return

            this.selectedIndex += direcao

            // loop no topo e fim da lista
            if (this.selectedIndex < 0) {
                this.selectedIndex = this.resultados.length - 1
            } else if (this.selectedIndex >= this.resultados.length) {
                this.selectedIndex = 0
            }

            this.$nextTick(() => {
                const ref = this.$refs['item-' + this.selectedIndex]
                if (ref && ref[0]) {
                    ref[0].scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest'
                    })
                }
            })
        },
        onInput() {
            this.buscarFuncionarios()
            this.$emit('input', '') // limpa o v-model se estiver digitando
        },
        focus() {
            this.$refs.input.focus()
        }
    }
}
</script>
  
<style scoped>
.autocomplete-wrapper {
    position: relative;
}

.result-list {
    position: absolute;
    z-index: 9999;
    /* acima do modal (que geralmente usa até 1040) */
    top: 100%;
    left: 0;
    width: 100%;
    background: #fff;
    max-height: 250px;
    overflow-y: auto;
    border: 1px solid #ccc;
    border-radius: 0 0 4px 4px;
    box-sizing: border-box;
    list-style: none;
    margin-top: 33px;
    padding-left: 0px;
}

.result-list-item {
    padding: 10px;
    cursor: pointer;
}

.result-list-item:hover {
    background-color: #f0f0f0;
}

.result-list-item.ativo {
    background-color: #eee;
    font-weight: bold;
    color: #00615c;
}

.custom-font {
    font-size: 16px;
    color: #00615c;
}

.fa-user {
    color: #00615c;
}
</style>
  


// WEBPACK FOOTER //
// src/components/SelectFuncionario.vue